module.exports = __webpack_public_path__ + "img/ring_r_0_1_0@2x.0cad6745.png";